export default __webpack_public_path__ + "fd3fe93ea66b6718b5e7c1439fe97463.svg";